<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width="600" persistent fluid scrollable content-class="round-2xl")
  v-card(min-height="45vh")
    v-card-title.pa-4
      v-row(no-gutters)
        v-col(cols="10" offset="1")
          .text-xl.font-bold.text-center Opportunities
        v-col(cols="1" align="right")
          v-btn(icon @click="closeDialog" small color="primary")
            v-icon mdi-close
    v-divider
    v-card-text.pa-6
      div.text-md.font-semibold.neutral700--text Things you can get done to boost your sales:
      div.d-flex.justify-center.mt-16(v-if="isFetching")
        v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
      template(v-else)
        template(v-for="(opportunity, index) in opportunities")
          v-card.round-xl.pa-4.mt-4(outlined :key="`opp-${index}`" link @click="selectOpportunity(opportunity)")
            div.d-flex.align-center
              v-avatar.round-lg.mr-2(size="28" color="purple500")
                v-icon(color="neutral100" size="14") $yzi-gift-solid-01
              div.text-sm.font-medium.purple500--text New suggestion
            v-row.mt-2(no-gutters)
              v-col
                div.text-md.font-medium.neutral700--text {{ opportunity.name }}
                div.text-sm.neutral700--text Setup this campaign suggestion and boost your sales
              v-col.shrink
                v-icon(color="neutral700" size="30") mdi-chevron-right
        template(v-if="!opportunities.length")
          .mt-4
            v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
            .mt-2.p2.basic600--text.text-center {{ $t('no_list_available') }}

    v-divider
    v-card-actions.py-4.px-6
      v-spacer
      y-button(label="Close" text-color="neutral100" color="neutral700" size="sm" dark @click="closeDialog")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {},
  props: {
    open: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      isFetching: false,
      isLoading: false,
      opportunities: [],
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {
    this.fetchOpportunities()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchOpportunities () {
      this.isFetching = true
      this.$axios.get(`/marketing/${this.company.slug}/opportunities`, { params: { setup: 0 } })
        .then(resp => {
          if (resp.data && resp.data.length) {
            this.opportunities = resp.data
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    selectOpportunity (opportunity) {
      this.$emit('selected', opportunity)
    },
    closeDialog () {
      this.$emit('closed')
      this.showDialog = false
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>